<template>
  <a-modal v-model="visible" :afterClose="resetModal">
    <a-form-model
      ref="deleteForm"
      :model="confirmDelete"
      :rules="rules"
      class="pt-4"
    >
      <a-form-model-item prop="password">
        <a-input-password
          class="mb-2 mt-2"
          size="large"
          v-model="confirmDelete.password"
          placeholder="Password"
        >
          <a-icon slot="prefix" type="lock" class="input-icon" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="companyName">
        <a-input
          size="large"
          v-model="confirmDelete.companyName"
          placeholder="Confirm company name"
        >
          <a-icon slot="prefix" type="bank" class="input-ico n" />
        </a-input> 
      </a-form-model-item>
      <a-form-model-item prop="keepBackup">
        <a-checkbox class="mt-2" v-model="confirmDelete.keepBackup">
          Keep Backup
        </a-checkbox>
      </a-form-model-item>
      <p>
        Are you sure you want to delete <b>{{ companyName }}</b
        >?
      </p>
    </a-form-model>
    <template slot="footer">
      <a-button type="danger" @click="ok" :loading="loading" :disabled="!formIsValid">Delete</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: Boolean,
    companyName: String,
    loading:Boolean,
  },
  data() {
    return {
      confirmDelete: {
        keepBackup: true,
        password: "",
        companyName: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please input your Password",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "Please input your Company Name!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    formIsValid: function () {
          return this.confirmDelete.password !== "" &&  this.confirmDelete.companyName !== "" ;
      },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    cancel() {
      this.visible = false;
    },
    ok() {
      this.$refs.deleteForm.validate(async (valid) => {
        if (valid) {
          this.$emit("delete", this.confirmDelete);
        }
      });
    },
    resetModal() {
      this.confirmDelete.password = "";
      this.confirmDelete.companyName = "";
      this.confirmDelete.keepBackup = true;
    },
  },
};
</script>
